import './rosemary2/style';
import FormStructure from './rosemary2/form_structure';

export default FormStructure;